import styled from 'styled-components';
import breakpoints from '../breakpoints';

const PageWrapper = styled.div<{
  $background?: string;
  $padding?: string;
  $fullWidth?: boolean;
}>`
  background-color: ${({ $background, theme }) =>
    $background || theme.colors.background};
  max-width: ${({ $fullWidth = false }) =>
    $fullWidth ? '100%' : breakpoints.xl};
  margin: 0 auto;
  padding: ${({ $padding = '1.625rem' }) => $padding};
  @media screen and (min-width: ${breakpoints.md}) {
    padding: ${({ $padding = '1.625rem' }) => $padding};
  }
`;

export default PageWrapper;
